import NativeFlex from 'components/NativePost/Bits/NativeFlex';
import { getNativeColor } from 'components/NativePost/Helpers';
import styled, { css } from 'components/_UI/designSystem';
import { theme } from '../constants';
import { StyledTextProps } from '../types';

// These are exposed to per network overrides
export const StyledHashtag = styled.span``;
export const StyledScreenName = styled.span``;
export const StyledUrl = styled.span``;

export const StyledEmoji = styled.img`
    vertical-align: middle;
`;

export const getLineClamp = lineClamp => {
    if (lineClamp?.enabled) {
        return css`
            -webkit-line-clamp: ${lineClamp.lines};
            display: -webkit-box;
            -webkit-box-orient: vertical;
        `;
    }
};

export const StyledNativeText = styled(NativeFlex)<StyledTextProps>`
    ${({ size }) =>
        size === 's' &&
        css`
            font-size: 1em;
        `};
    ${({ size }) =>
        size === 'l' &&
        css`
            font-size: 1.5em;
        `};
    ${({ rtl }) =>
        rtl === true &&
        css`
            direction: rtl;
            text-align: right;
        `};

    ${({ colorMode }) =>
        css`
            color: ${getNativeColor(theme, colorMode, 'text')};
        `}
    ${StyledEmoji} {
        height: 1em;
        width: 1em;
    }

    font-weight: 400;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    ${props => getLineClamp(props.lineClamp)};
`;
